import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { HashLink as Link } from 'react-router-hash-link';
import logo from "../HeaderSection/logo.svg";
import metamask from "../../images/metamask.png";
import Wallet from "../../images/wallet.png";
import Modal from '@mui/material/Modal';
import { InjectedConnector } from '@web3-react/injected-connector';
import { WalletConnectConnector } from '@web3-react/walletconnect-connector';
import {API_URL, Bsc_RPC_URL} from "../../Config/index";
import { useWeb3React } from '@web3-react/core';
import { useDispatch, useSelector } from "react-redux";
import { accountInfos, removeInfo } from "../../Redux/userinfo";
import axios from 'axios';
import { useEffect } from 'react';
import swal from "sweetalert";
import Swal from 'sweetalert2';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const walletconnect = new WalletConnectConnector({
    // rpc:{56 : RPC_URL},
    rpc: { 97: Bsc_RPC_URL },
    bridge: "https://bridge.walletconnect.org",
    qrcode: true,
    pollingInterval: 2000,
    qrcodeModalOptions: {
        mobileLinks: ["metamask", "trust"],
    },
});

const pages = [

    {
        text: 'Home',
        route: '/'
    }, 
    {
        text: 'CreateCollections',
        route: '/Createcollection'
    },
    {
        text: 'Explore',
        route: '/Explore'
    },
    {
        text: 'Profile',
        route: '/Myitem'
    },
    {
        text: 'Membership',
        route: '/Membershipplan'
    },
    {
        text: 'Contact',
        route: '/Contactus'
    },
    {
        text: 'MembershipNFT',
        route: '/MembershipNFT'
    },

]

const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const ResponsiveAppBar = () => {
    const { library, chainId, account, activate, deactivate, active} = useWeb3React();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const injected = new InjectedConnector({ supportedChainIds: [56, 97, 5, 1, 2, 3, 4, 80001, 137] });
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [wallet, setWallet] = React.useState("");
    const dispatch = useDispatch();

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    async function connect(provider, walletType) {
        console.log(provider,"provider");
        if(window.ethereum){
            try {
                await activate(provider);
                setWallet(walletType);
                localStorage.setItem('wallet',walletType);
                handleClose();
            } catch (e) {
                console.error("connect: ", e);
            }

        }else{
           
            handleClose();
              Swal.fire({
                icon: 'warning',
                title: "Couldn't find Metamask!...",
                html: "You can download it from" + "<a target='blank' href='https://metamask.io/'>https://metamask.io/ </a>" + "or try connecting via WalletConnect!",
            })
        }
    }

    async function disconnect() {
        try {
            deactivate();
            dispatch(removeInfo());
            
        } catch (ex) {
            console.log(ex);
        }
    }

    
    const initializeConnection = () => {
        try {
            if (active == true) {
                let isConnected = active;
                let accountAddress = account;
                let provider = library;
                let info = {
                    isConnected,
                    provider,
                    accountAddress,
                    chainId,
                    wallet,
                };
                dispatch(accountInfos(info));
             
            }
        } catch (err) {
          console.log(err);

        }
    };

    
    React.useEffect(() => {
        initializeConnection();
    }, [active, account, wallet, chainId]);

    const adduserinfo = async()=>{
        var data = new FormData();
        data.append("address", account);
      
        return await axios.post(`${API_URL}/insertNewUser.php`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((res)=>{

        });
    }
    
    useEffect(()=>{
        if(active){
           adduserinfo();
        }

    },[active])

    const checkconnected = async()=>{

        let isConnected = localStorage.isConnected;
        let wallet = localStorage.wallet;
        
        if(isConnected=='true'){
            if(wallet=="metamask"){
                await activate(injected);
            }else if(wallet=="walletConnect"){
                await activate(walletconnect);
            }
        }
    }

    useEffect(()=>{
        checkconnected();
    },[])

    return (
        <AppBar position="static" className='main_header'  style={{ backgroundColor: '#000', boxShadow: 'none' }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography variant="h6" noWrap component="div" sx={{ mr: 10, display: { xs: 'none', md: 'flex' } }}>
                        <Link to='/'>
                            <img src={logo} width="100%" />
                        </Link>
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large" aria-label="account of current user" aria-controls="menu-appbar"
                            aria-haspopup="true" onClick={handleOpenNavMenu} color="inherit" >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {pages.map((page) => (
                               <MenuItem component={Link} to={page.route} key={page.text}
                               onClick={handleCloseNavMenu}>
                               <Typography textAlign="center">{page.text}</Typography>
                           </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <Typography variant="h6" noWrap component={Link} to='/'  sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <img src='./img/fav.png' className='mob_icon'/>
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page) => (
                            <Button className='menus'
                                component={Link} disableRipple scroll={(el) => {
                                    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
                                    const yOffset = -65;
                                    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
                                }}
                                to={page.route}
                                key={page.text} onClick={handleCloseNavMenu} sx={{ my: 2, color: 'white', display: 'block' }}>
                                {page.text}
                            </Button>
                        ))}
                    </Box>

                    <Box sx={{ flexGrow: 0 }}>
                       {active && <Box className='cont_add'> {account.substring(0,10)} </Box>}
                      {active ?<Button className='connect_walt' variant='Contained' onClick={disconnect}> Disconnect</Button>:<Button className='connect_walt' variant='Contained' onClick={handleOpen}> Connect Wallet</Button>}  
                    
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {settings.map((setting) => (
                                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                    <Typography textAlign="center">{setting}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Toolbar>
                <>

                    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box sx={style} className='connect_btns'>

                            <Box>
                                <Typography variant='h4' paddingBottom='20px' fontSize='25px' fontWeight='bold'>Wallet Connect</Typography>
                                <Button flat color="success" style={{ width: '100%' }} justifyContent='space-between' onClick={() => connect(injected, "metamask")}>
                                    Metamask Wallet <img src={metamask} width='20px' />
                                </Button>
                                <Box marginY='1rem'>
                                    <Button flat color="success" style={{ width: '100%', }} onClick={() => connect(walletconnect, "walletConnect")}>
                                        Wallet Connect <img src={Wallet} width='20px' />
                                    </Button>
                                </Box>
                                
                            </Box>
                        </Box>
                    </Modal>
                </>
            </Container>
        </AppBar>
    );
};
export default ResponsiveAppBar;
